import { Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import { AppTitles } from '@tbd/lift-portal-shared-config';
import type { AppName } from '@tbd/lift-portal-shared-config';

const DEFAULT_SX = {};
export interface AppTitleProps {
  appName: AppName;
  color: 'white' | 'black';
  title?: string;
  variant?: TypographyProps['variant'];
  sx?: TypographyProps['sx'];
}

export function AppTitle(props: AppTitleProps) {
  const {
    appName,
    color,
    title = AppTitles[appName],
    variant = 'component-bold-m',
    sx = DEFAULT_SX,
  } = props;
  return (
    <Typography
      variant={variant}
      noWrap
      component="h1"
      sx={{
        color,
        letterSpacing: '-0.02em',
        fontWeight: 600,
        fontSize: { xs: '14px', md: '18px' },
        lineHeight: { xs: '16px', md: '24px' },
        ...sx,
      }}
    >
      {title}
    </Typography>
  );
}
